// "use client";

// import React, { useEffect, useState } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import { toast } from "react-toastify";

// import {
//     getStockBanner,
//  updateStockBannerStatusServ
// } from "../../../services/support.service";

// const StockBanner = () => {
//   const [loading, setLoading] = useState(false);

//   const [payload, setPayload] = useState({
//     status: "available",
//     message: "",
//   });

//   // GET CURRENT STATUS
//   const handleGetStatus = async () => {
//     try {
//       const response = await getStockBanner();

//       if (response?.data) {
//         setPayload({
//           status:
//             response?.data?.status || "available",
//           message: response?.data?.message || "",
//         });
//       }
//     } catch (error) {
//       console.log("get stock status error", error);
//     }
//   };

//   // UPDATE STATUS
//   const handleUpdateStatus = async () => {
//     setLoading(true);

//     try {
//       const response = await updateStockBannerStatusServ(payload);

//       toast.success(
//         response?.data?.message ||
//           "Stock status updated successfully"
//       );
//     } catch (error) {
//       console.log("update stock status error", error);

//       toast.error("Failed to update stock status");
//     }

//     setLoading(false);
//   };

//   useEffect(() => {
//     handleGetStatus();
//   }, []);

//   return (
//     <div className="bodyContainer">
//       <Sidebar
//         selectedMenu={"System Support"}
//         selectedItem={"Stock Banner"}
//       />

//       <div className="mainContainer">
//         <TopNav />

//         <div className="p-lg-4 p-md-3 p-2">

//           <div className="card shadow-sm border-0 p-4">

//             <h3 className="mb-4 text-secondary">
//               Top Banner Stock Status
//             </h3>

//             {/* STOCK STATUS */}
//             <div className="mb-4">
//               <label className="form-label">
//                 Select Stock Status
//               </label>

//               <select
//                 className="form-select"
//                 value={payload?.status}
//                 onChange={(e) =>
//                   setPayload({
//                     ...payload,
//                     status: e.target.value,
//                   })
//                 }
//               >
//                 <option value="available">
//                   Available
//                 </option>

//                 <option value="low_stock">
//                   Low Stock
//                 </option>

//                 <option value="sold_out">
//                   Sold Out
//                 </option>
//               </select>
//             </div>

//             {/* CUSTOM MESSAGE */}
//             {/* <div className="mb-4">
//               <label className="form-label">
//                 Banner Message
//               </label>

//               <textarea
//                 rows={4}
//                 className="form-control"
//                 placeholder="Enter banner message"
//                 value={payload?.message}
//                 onChange={(e) =>
//                   setPayload({
//                     ...payload,
//                     message: e.target.value,
//                   })
//                 }
//               />
//             </div> */}

//             {/* BUTTON */}
//             <button
//               className="btn btn-dark px-4"
//               onClick={handleUpdateStatus}
//               disabled={loading}
//             >
//               {loading ? "Updating..." : "Update Status"}
//             </button>

//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default StockBanner;


"use client";

import React, { useEffect, useState } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import { toast } from "react-toastify";

import {
  getStockBanner,
  updateStockBannerStatusServ,
} from "../../../services/support.service";

/* ─── Scoped Styles ───────────────────────── */
const styles = `
  .sb-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  .sb-grid {
    display: grid;
    grid-template-columns: 1fr 340px;
    gap: 20px;
    align-items: start;
  }

  @media (max-width: 992px) {
    .sb-grid {
      grid-template-columns: 1fr;
    }
  }

  .sb-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .sb-card-header {
    padding: 22px 24px;
    border-bottom: 1px solid #f7f5f5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    flex-wrap: wrap;
  }

  .sb-title-wrap {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .sb-icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
  }

  .sb-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
    margin-bottom: 4px;
  }

  .sb-subtitle {
    font-size: 14px;
    color: #999;
  }

  .sb-body {
    padding: 24px;
  }

  .sb-field {
    margin-bottom: 24px;
  }

  .sb-label {
    display: block;
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #444;
  }

  .sb-select-wrap {
    position: relative;
  }

  .sb-select-icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #a60808;
    font-size: 16px;
    z-index: 1;
  }

  .sb-select {
    width: 100%;
    height: 52px;
    border-radius: 12px;
    border: 1px solid #f0eded;
    background: #fafafa;
    padding: 0 16px 0 44px;
    font-size: 14px;
    color: #444;
    outline: none;
    appearance: none;
    transition: all 0.18s ease;
    cursor: pointer;
  }

  .sb-select:focus {
    border-color: #f0c0b8;
    background: #fff;
  }

  .sb-btn {
    height: 48px;
    padding: 0 24px;
    border: none;
    border-radius: 12px;
    background: #a60808;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.18s ease;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .sb-btn:hover:not(:disabled) {
    background: #a93226;
  }

  .sb-btn:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }

  .sb-status-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 22px;
  }

  .sb-status-title {
    font-size: 18px;
    font-weight: 700;
    color: #1c0a0a;
    margin-bottom: 22px;
  }

  .sb-status-box {
    border-radius: 16px;
    padding: 22px;
    border: 1px solid transparent;
  }

  .sb-status-box.available {
    background: #eaf3de;
    border-color: #d6e8c2;
  }

  .sb-status-box.low_stock {
    background: #faeeda;
    border-color: #f3ddb3;
  }

  .sb-status-box.sold_out {
    background: #fdf2f1;
    border-color: #f3c8c3;
  }

  .sb-status-icon {
    width: 54px;
    height: 54px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    font-size: 24px;
  }

  .available .sb-status-icon {
    background: #dceec9;
    color: #3b6d11;
  }

  .low_stock .sb-status-icon {
    background: #f7dfb3;
    color: #854f0b;
  }

  .sold_out .sb-status-icon {
    background: #f7d7d4;
    color: #a60808;
  }

  .sb-status-label {
    font-size: 13px;
    color: #888;
    margin-bottom: 6px;
  }

  .sb-status-value {
    font-size: 22px;
    font-weight: 700;
    text-transform: capitalize;
  }

  .available .sb-status-value {
    color: #3b6d11;
  }

  .low_stock .sb-status-value {
    color: #854f0b;
  }

  .sold_out .sb-status-value {
    color: #a60808;
  }

  .sb-status-desc {
    margin-top: 10px;
    font-size: 14px;
    line-height: 1.6;
    color: #666;
  }
`;

const STATUS_META = {
  available: {
    icon: "ti-package",
    label: "Available",
    desc: "Products are currently available and ready for purchase.",
  },

  low_stock: {
    icon: "ti-alert-triangle",
    label: "Low Stock",
    desc: "Limited stock remaining. Users will see urgency banner.",
  },

  sold_out: {
    icon: "ti-shopping-cart-off",
    label: "Sold Out",
    desc: "Products are currently unavailable for purchase.",
  },
};

const StockBanner = () => {
  const [loading, setLoading] = useState(false);

  const [payload, setPayload] = useState({
    status: "available",
    message: "",
  });

  // GET CURRENT STATUS
  const handleGetStatus = async () => {
    try {
      const response = await getStockBanner();

      if (response?.data) {
        setPayload({
          status: response?.data?.status || "available",
          message: response?.data?.message || "",
        });
      }
    } catch (error) {
      console.log("get stock status error", error);
    }
  };

  // UPDATE STATUS
  const handleUpdateStatus = async () => {
    setLoading(true);

    try {
      const response = await updateStockBannerStatusServ(
        payload
      );

      toast.success(
        response?.data?.message ||
          "Stock status updated successfully"
      );
    } catch (error) {
      console.log("update stock status error", error);

      toast.error("Failed to update stock status");
    }

    setLoading(false);
  };

  useEffect(() => {
    handleGetStatus();
  }, []);

  return (
    <div className="bodyContainer">
      <style>{styles}</style>

      <Sidebar
        selectedMenu={"System Support"}
        selectedItem={"Stock Banner"}
      />

      <div className="mainContainer">
        <TopNav
          pageTitle="Stock Banner"
          pagePath="Home / System Support / Stock Banner"
        />

        <div className="sb-page">

          <div className="sb-grid">

            {/* ── Main Card ── */}
            <div className="sb-card">

              <div className="sb-card-header">

                <div className="sb-title-wrap">

                  <div className="sb-icon">
                    <i className="ti ti-speakerphone" />
                  </div>

                  <div>
                    <div className="sb-title">
                      Top Banner Stock Status
                    </div>

                    <div className="sb-subtitle">
                      Manage product stock visibility banner
                    </div>
                  </div>

                </div>

              </div>

              <div className="sb-body">

                {/* STATUS */}
                <div className="sb-field">

                  <label className="sb-label">
                    Select Stock Status
                  </label>

                  <div className="sb-select-wrap">

                    <i className="ti ti-package sb-select-icon" />

                    <select
                      className="sb-select"
                      value={payload?.status}
                      onChange={(e) =>
                        setPayload({
                          ...payload,
                          status: e.target.value,
                        })
                      }
                    >
                      <option value="available">
                        Available
                      </option>

                      <option value="low_stock">
                        Low Stock
                      </option>

                      <option value="sold_out">
                        Sold Out
                      </option>

                    </select>
                  </div>
                </div>

                {/* BUTTON */}
                <button
                  className="sb-btn"
                  onClick={handleUpdateStatus}
                  disabled={loading}
                >
                  <i className="ti ti-device-floppy" />

                  {loading
                    ? "Updating..."
                    : "Update Status"}
                </button>

              </div>
            </div>

            {/* ── Status Preview ── */}
            <div className="sb-status-card">

              <div className="sb-status-title">
                Current Status
              </div>

              <div
                className={`sb-status-box ${payload?.status}`}
              >

                <div className="sb-status-icon">
                  <i
                    className={`ti ${
                      STATUS_META[payload?.status]?.icon
                    }`}
                  />
                </div>

                <div className="sb-status-label">
                  Active Banner Status
                </div>

                <div className="sb-status-value">
                  {
                    STATUS_META[payload?.status]
                      ?.label
                  }
                </div>

                <div className="sb-status-desc">
                  {
                    STATUS_META[payload?.status]
                      ?.desc
                  }
                </div>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
};

export default StockBanner;